
(function () {
  "use strict";

  const ACCEPT_ID = "shopify-pc__banner__btn-accept";
  const DECLINE_ID = "shopify-pc__banner__btn-decline";
  const TEST_ID = "shopify-pc__banner__btn-accept-test";
  const PRIVACY_LINK_ID = "shopify-pc__banner__body-policy-link";

  // ==========================================
  // 1. Testbutton erstellen
  // ==========================================

  function setupTestButton() {
    const acceptButton = document.getElementById(ACCEPT_ID);
    const declineButton = document.getElementById(DECLINE_ID);

    if (!acceptButton || !declineButton) {
      return;
    }

    // Neuen Button erstellen
    const testButton = document.createElement("button");

    testButton.id = TEST_ID;
    testButton.type = "button";

    // Sprache anhand der URL bestimmen
    const pathname = window.location.pathname;

    const isCanada =
      pathname === "/en-ca" ||
      pathname.startsWith("/en-ca/");

    const isSweden =
      pathname === "/sv-se" ||
      pathname.startsWith("/sv-se/");

    // Button-Beschriftung je nach Markt
    if (isCanada) {
      testButton.textContent = "Decline";
    } else if (isSweden) {
      testButton.textContent = "Avvisa";
    } else {
      testButton.textContent = "Ablehnen";
    }

    // Klick löst originale Akzeptieren-Funktion aus
    testButton.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const originalAccept = document.getElementById(ACCEPT_ID);

      if (originalAccept) {
        originalAccept.click();
      }
    });

    // Originalen Ablehnen-Button ersetzen
    declineButton.replaceWith(testButton);
  }

  // ==========================================
  // 2. Datenschutz-Link im gleichen Tab öffnen
  // ==========================================

  function updatePrivacyPolicyLink() {
    const policyLink = document.getElementById(PRIVACY_LINK_ID);

    if (!policyLink) {
      return;
    }

    // Neuen Tab verhindern
    if (policyLink.getAttribute("target") !== "_self") {
      policyLink.setAttribute("target", "_self");
    }
  }

  // ==========================================
  // 3. Funktionen initial ausführen
  // ==========================================

  setupTestButton();
  updatePrivacyPolicyLink();

  // ==========================================
  // 4. Shopify Banner dynamisch überwachen
  // ==========================================

  const observer = new MutationObserver(function () {

    // Falls Shopify den Ablehnen-Button nachlädt
    if (document.getElementById(DECLINE_ID)) {
      setupTestButton();
    }

    // Datenschutz-Link ebenfalls aktualisieren
    updatePrivacyPolicyLink();

  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["target"]
  });

})();
